import lpApp from '../lp_app';
import { ConditionRuntime } from '../../logic/condition_tree';
import {
  ckCUpdateCardNumber, ckCheckCondition, ckCUpdateCardExpiration, ckCUpdateCCV,
} from '../../redux/actions/checkout_operations';

/*
 * Project: LegalPlace assistant
 * File: src/app/ops/checkout.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
*/

class LpOpsCheckout {
  constructor() {
    this.showCreditCardModal = () => {};
  }

  static isProInd() {
    const state = lpApp.getState();
    let pro = true;
    const proTest = state.contract.client_type;
    // TODO: Check condition is not null
    switch (proTest) {
      case 'COND':
        if (state.contract.pro_condition.length === 0) pro = false;
        else {
          const proCond = new ConditionRuntime(state.contract.pro_condition);
          proCond.compileDirect();
          pro = proCond.execute(true);
        }

        break;
      case 'PRO':
        pro = true;
        break;
      default:
        break;
    }
    return pro;
  }

  /**
     * Gets the chosen pack for payment
     * @returns {number} 0 for the first selection and 1 for the sencod selection
     */
  getPackId() {
    return lpApp.getState().checkout_operations.pack;
  }

  getPackPrice() {
    return Object.values(lpApp.getState().checkout_operations.prices)[this.getPackId()];
  }

  static detectLetters() {
    let letters;
    if (lpApp.getState().checkout_operations.has_letter) {
      letters = lpApp.getState().checkout_operations.letter;
    } else letters = false;

    return letters;
  }

  static detectLawyer() {
    return lpApp.getState().checkout_operations.has_call;
  }

  static getPromotionPercentage() {
    if (Number.isNaN(parseFloat(lpApp.getState().checkout_operations.promo_percentage)) || typeof price === 'string') return 1.0;

    return 1 - lpApp.getState().checkout_operations.promo_percentage;
  }

  getTTCPrice() {
    const pro = LpOpsCheckout.isProInd();
    const lawyer = LpOpsCheckout.detectLawyer() ? 29.9 : 0;
    let letters = LpOpsCheckout.detectLetters();
    letters = letters ? Math.abs(letters.number) * 3.9 : 0;
    // devenir-coursier
    if ( lpApp.contractMetaId === 302)
    return parseFloat(this.getPackPrice() * 1.2).toFixed(2)
    return parseFloat(
      (!pro
        ? parseFloat(this.getPackPrice())
        : parseFloat(this.getPackPrice() * 1.2))
      * LpOpsCheckout.getPromotionPercentage() + lawyer + letters,
    ).toFixed(2);
  }

  getHTPrice() {
    const pro = LpOpsCheckout.isProInd();
    const lawyer = LpOpsCheckout.detectLawyer() ? 29.9 : 0;
    let letters = LpOpsCheckout.detectLetters();
    letters = letters ? Math.abs(letters.number) * 3.9 : 0;
    if ( lpApp.contractMetaId === 302)
    return parseFloat(this.getPackPrice()).toFixed(2)
    return parseFloat(
      (!pro
        ? parseFloat(this.getPackPrice()) / 1.2
        : parseFloat(this.getPackPrice()))
      * LpOpsCheckout.getPromotionPercentage() + lawyer + letters,
    ).toFixed(2);
  }

  resetCreditCardInformation() {
    lpApp.dispatch(ckCheckCondition(false));
    lpApp.dispatch(ckCUpdateCardNumber(''));
    lpApp.dispatch(ckCUpdateCardExpiration(''));
    lpApp.dispatch(ckCUpdateCCV(''));
  }

  resetCheckedCondition() {
    lpApp.dispatch(ckCheckCondition(false));
  }

  setCheckoutCallback(callback) {
    this.showCreditCardModal = callback;
  }

  isInvoiceActivated() {
    return lpApp.getState().checkout_operations.toggle_invoice;
  }

  getInvoice() {
    return lpApp.getState().checkout_operations.invoice;
  }
}

export default LpOpsCheckout;



// WEBPACK FOOTER //
// ./src/app/ops/checkout.js